/* The Miku set images are product files. Dawn still owns the media gallery and
   variant selection; this swaps only the selected set preview in that gallery. */
(() => {
  const sets = {
    '7pcs': {
      src: 'https://cdn.shopify.com/s/files/1/0684/3826/1917/files/cg-miku-7-piece-set-matched-header.png?v=1790454015',
      alt: 'Branded preview of the Miku 7-piece core costume set',
    },
    '9pcs': {
      src: 'https://cdn.shopify.com/s/files/1/0684/3826/1917/files/cg-miku-9-piece-set-branded.png?v=1790453396',
      alt: 'Branded preview of the Miku 9-piece set with headset and headwear',
    },
    '10pcs': {
      src: 'https://cdn.shopify.com/s/files/1/0684/3826/1917/files/cg-miku-10-piece-set-matched-header.png?v=1790454020',
      alt: 'Branded preview of the Miku 10-piece set with the long aqua wig',
    },
  };

  const apply = (section, variant) => {
    const setName = variant?.option1;
    const image = sets[setName];
    const mediaId = variant?.featured_media?.id;
    if (!image || !mediaId) return;
    const gallery = section.querySelector('media-gallery');
    const item = gallery?.querySelector(`[data-media-id="${section.dataset.section}-${mediaId}"]`);
    const img = item?.querySelector('.product__modal-opener--image img');
    if (!img) return;

    const url = new URL(image.src);
    img.srcset = [540, 750, 990, 1426, 1946].map((width) => {
      url.searchParams.set('width', width);
      return `${url.href} ${width}w`;
    }).join(', ');
    img.src = image.src;
    img.alt = image.alt;

    const modalImg = document.getElementById(`ProductModal-${section.dataset.section}`)?.querySelector(`img[data-media-id="${mediaId}"]`);
    if (modalImg) {
      modalImg.srcset = img.srcset;
      modalImg.src = image.src;
      modalImg.alt = image.alt;
    }

    const thumbnail = gallery?.querySelector(`[data-target="${section.dataset.section}-${mediaId}"] img`);
    if (thumbnail) {
      thumbnail.srcset = '';
      url.searchParams.set('width', '360');
      thumbnail.src = url.href;
      thumbnail.alt = image.alt;
    }
  };

  const start = () => {
    const section = document.querySelector('.cg-product-landing--miku');
    if (!section || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (new URLSearchParams(location.search).has('variant')) {
      try { apply(section, JSON.parse(section.querySelector('variant-selects [data-selected-variant]').textContent)); }
      catch (error) { console.warn('Miku set preview could not initialize', error); }
    }
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== section.dataset.section) return;
      requestAnimationFrame(() => apply(section, data.variant));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
